export type TwoLineSkeletonProps = {
  showSecondLine?: boolean
}

export function TwoLineSkeleton({ showSecondLine = true }: TwoLineSkeletonProps) {
  return (
    <div className='flex flex-col gap-2'>
      <div className='h-[9px] max-w-[72px] bg-grey80 animate-pulse rounded' />
      {showSecondLine && (
        <div className='w-[200px] h-[15px] bg-grey80 animate-pulse rounded' />
      )}
    </div>
  )
}

